export const profileCollapse = () => ({
  expanded: false,
  collapsible: false,

  toggle() {
    this.expanded = !this.expanded;
    this.$refs.icon.classList.toggle('-rotate-180');
  },

  update() {
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    this.$nextTick(() => {
      this.collapsible = !isDesktop && this.$refs.content.scrollHeight > 300;
      if (!this.collapsible) this.expanded = false;
    });
  },

  init() {
    this.update();
  },
});
